import { render, staticRenderFns } from "./WlsCustomerAging.vue?vue&type=template&id=16460a08"
import script from "./WlsCustomerAging.vue?vue&type=script&lang=ts"
export * from "./WlsCustomerAging.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports